var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SlidingPanel",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isSettingsPanelOpen,
          expression: "isSettingsPanelOpen"
        }
      ],
      ref: "SettingsPanel",
      staticClass: "powerbar-settings-panel",
      attrs: { id: "SettingsPanel", enterFrom: "right" }
    },
    [
      !!_vm.username
        ? [
            _c("div", { staticClass: "ax-pill" }, [
              !!_vm.username
                ? _c(
                    "p",
                    {
                      staticClass:
                        "ax-pill--low-attention powerbar-settings-panel__group-heading powerbar-settings-panel__group-heading--username"
                    },
                    [_vm._v(_vm._s(_vm.username))]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "powerbar-settings-panel__group-heading mt-0" },
              [_vm._v("Manage your Class account")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.username
        ? [
            _c("p", { staticClass: "powerbar-settings-panel__group-heading" }, [
              _vm._v("Manage your Class account")
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "powerbar-settings-panel__links-group" }, [
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: _vm.changePasswordUrl },
              on: { click: _vm.closeSettings }
            },
            [_vm._v("Change password")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: "/my/login/security-questions" },
              on: { click: _vm.closeSettings }
            },
            [_vm._v("Reset multi-factor authentication")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: "/my/login/security-questions/manage" },
              on: { click: _vm.closeSettings }
            },
            [_vm._v("Manage security questions")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: "/auditor" },
              on: { click: _vm.closeSettings }
            },
            [_vm._v("Manage Auditor Representatives")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: "/my/business-summary?RememberTableState=False" },
              on: { click: _vm.closeSettings }
            },
            [_vm._v("Change business")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "powerbar-settings-panel__links-group-item" }, [
          _c(
            "a",
            {
              staticClass: "powerbar-settings-panel__link",
              attrs: { href: "/my/logout" }
            },
            [_vm._v("Log out")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }